module.exports = __webpack_public_path__ + "static/media/img_welcome_bg@2x.a047fd17.png";